export const Element = {
  CardNumber: 'cardNumber',
  FirstName: 'firstName',
  LastName: 'lastName',
  ExpiryMonth: 'expiryMonth',
  ExpiryYear: 'expiryYear',
  Cvv: 'cvv',
} as const;

export const FamilyName = {
  credit_expert: 'CreditExpert',
  identity: 'Identity Plus',
} as const;

export const InputState = {
  Standard: 'standard',
  Error: 'error',
  Success: 'success',
  Disabled: 'disabled',
} as const;

export const MaxNameLength = 50;

export const MinNameLength = 1;

export const PaymentCard = {
  Existing: 'existing',
  New: 'new',
} as const;

export const PaymentMethodTypes = {
  Card: 'card',
  ApplePay: 'applePay',
  GooglePay: 'gpay',
  NewGpay: 'new_gpay',
  NewApplePay: 'new_apple_pay',
} as const;

export const TrialDuration = 30;

export const MerchantId = {
  GooglePay: 'BCR2DN4T27LYJ7RH',
} as const;

// Type exports
export type ElementType = (typeof Element)[keyof typeof Element];
export type FamilyNameType = (typeof FamilyName)[keyof typeof FamilyName];
export type InputStateType = (typeof InputState)[keyof typeof InputState];
export type PaymentCardType = (typeof PaymentCard)[keyof typeof PaymentCard];
export type PaymentMethodType = (typeof PaymentMethodTypes)[keyof typeof PaymentMethodTypes];
export type MerchantIdType = (typeof MerchantId)[keyof typeof MerchantId];
